import { Node, mergeAttributes } from '@tiptap/core';

export const ComprehensionCheck = Node.create({
  name: 'comprehensionCheck',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      question: {
        default: '',
      },
      options: {
        // JSON string: [{ label: "A", text: "...", correct: true/false }]
        default: '[]',
      },
      explanation: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="comprehension-check"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const question = HTMLAttributes.question || '';
    const optionsStr = HTMLAttributes.options || '[]';
    const explanation = HTMLAttributes.explanation || '';

    // Stable ID from question text
    const hashCode = (str) => {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
      }
      return Math.abs(hash).toString(36);
    };
    const blockId = `cc-${hashCode(question)}`;

    let options;
    try {
      options = JSON.parse(optionsStr);
    } catch {
      options = [];
    }

    // Build the element tree
    const elements = [
      'div',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'comprehension-check',
        'data-block-id': blockId,
        'data-options': optionsStr,
        'data-explanation': explanation,
        class: 'comprehension-check-block',
      }),
    ];

    // Header with icon and label
    elements.push([
      'div',
      { class: 'cc-header' },
      ['span', { class: 'cc-icon' }, ''],
      ['span', { class: 'cc-label' }, 'Check Your Understanding'],
    ]);

    // Question text
    elements.push(['div', { class: 'cc-question' }, question]);

    // Options container
    const optionsContainer = ['div', { class: 'cc-options', 'data-block-id': blockId }];

    options.forEach((opt) => {
      optionsContainer.push([
        'button',
        {
          type: 'button',
          class: 'cc-option',
          'data-block-id': blockId,
          'data-label': opt.label,
          'data-correct': opt.correct ? 'true' : 'false',
        },
        ['span', { class: 'cc-option-label' }, opt.label],
        ['span', { class: 'cc-option-text' }, opt.text || opt.label],
      ]);
    });

    elements.push(optionsContainer);

    // Feedback area (hidden by default, shown after answer)
    elements.push([
      'div',
      {
        class: 'cc-feedback',
        'data-block-id': blockId,
        style: 'display: none;',
      },
      '',
    ]);

    return elements;
  },

  addCommands() {
    return {
      setComprehensionCheck:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
});

export default ComprehensionCheck;
